import React from 'react';
import {
  Box,
  Button,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const ConversationList = ({ conversations, activeId, onSelect, onCreate, onDelete }) => (
  <Box
    sx={{
      width: 268,
      flexShrink: 0,
      borderRight: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    }}
  >
    <Box sx={{ p: 1.5 }}>
      <Button fullWidth variant="outlined" startIcon={<AddIcon />} onClick={onCreate}>
        New chat
      </Button>
    </Box>

    <List dense sx={{ overflowY: 'auto', flex: 1, px: 0.5 }}>
      {conversations.length === 0 ? (
        <Typography sx={{ px: 2, py: 1, color: 'text.secondary', fontSize: 13.5 }}>
          No conversations yet.
        </Typography>
      ) : null}

      {conversations.map((conversation) => (
        <ListItemButton
          key={conversation.id}
          selected={conversation.id === activeId}
          onClick={() => onSelect(conversation.id)}
          sx={{
            borderRadius: 1.5,
            mb: 0.25,
            pr: 0.5,
            '& .delete-action': { opacity: 0 },
            '&:hover .delete-action': { opacity: 1 },
          }}
        >
          <ListItemText
            primary={conversation.title || 'Untitled'}
            primaryTypographyProps={{
              noWrap: true,
              fontSize: 13.5,
              fontWeight: conversation.id === activeId ? 600 : 400,
            }}
          />
          <IconButton
            className="delete-action"
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              onDelete(conversation.id);
            }}
          >
            <DeleteOutlineIcon fontSize="inherit" />
          </IconButton>
        </ListItemButton>
      ))}
    </List>
  </Box>
);

export default ConversationList;
